<template>
    <div class=" border-2 p-4 md:mt-16 rounded-lg games-elements-bg-light  games-elements-border w-full md:w-auto">
        <div class="flex flex-col space-y-6 justify-around  2xl:mt-4">
            <!-- set time -->
            <div class="">
                <select v-model="new_time" id="times" class="border text-lg rounded-lg block w-full p-2">
                    <option  v-for="t in [40,50,60,70,80,90,100]" :key="t" :value="t">
                        {{ t }} {{ $t('elements_title_second') }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script setup>
import Bg from '../other/Bg.vue'
import {ref, watch} from 'vue';
const emit = defineEmits(['screen', 'multiplier'])
const props = defineProps(['time', 'volume'])
const new_time = ref(props.time)

watch(new_time, (current_time) => {
    emit('multiplier', {'selected':'time', 'number':current_time})
});
</script>
